import { useEffect, useState } from "react";
import { supabase } from "../../../lib/supabase";
import { useToast } from "../../../components/Toast";

const PROGRESS_COLUMNS =
  "student_id, template_id, response, completed, completed_at, updated_at";
const PAGE_SIZE = 1000;

const EMPTY = { templates: [], progress: [], students: [] };

// student_progress supera el límite de filas por petición de PostgREST, así que
// se pagina con .range(). El avance va por filas recibidas, no por PAGE_SIZE:
// si el servidor devuelve menos de las pedidas no se corta el informe.
async function fetchAllProgress() {
  const rows = [];
  let from = 0;
  for (;;) {
    const { data, error } = await supabase
      .from("student_progress")
      .select(PROGRESS_COLUMNS)
      .order("student_id")
      .order("template_id")
      .range(from, from + PAGE_SIZE - 1);
    if (error) throw error;
    if (!data || data.length === 0) return rows;
    rows.push(...data);
    from += data.length;
  }
}

// Los datos se descargan al montar la página: lo que se difiere es el RENDER
// del informe, no la carga, para que el panel de selección abra con todo listo.
export function useActivityReportData() {
  const { showError } = useToast();
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  const load = async () => {
    setLoading(true);
    setFailed(false);
    try {
      const [templatesRes, progressRows, studentsRes] = await Promise.all([
        supabase
          .from("activity_templates")
          .select("*")
          .order("block_order")
          .order("sort_order"),
        fetchAllProgress(),
        supabase
          .from("students")
          .select("id, name, email, airtable_id")
          .order("name"),
      ]);

      if (templatesRes.error) throw templatesRes.error;
      if (studentsRes.error) throw studentsRes.error;

      setData({
        templates: templatesRes.data || [],
        progress: progressRows,
        // Los admin no son alumnos del programa; se filtra en memoria para no
        // perder a los alumnos con airtable_id nulo.
        students: (studentsRes.data || []).filter(
          (student) => !(student.airtable_id || "").startsWith("admin_")
        ),
      });
    } catch {
      showError("Error al cargar el informe de respuestas");
      setFailed(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return { ...data, loading, failed, reload: load };
}
